module.exports = __webpack_public_path__ + "img/banner.dd8c5d26.png";